// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Recoil$OrcaPaymentPage from "../libraries/Recoil.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";

var paymentManagementList = Recoil$OrcaPaymentPage.atom("paymentManagementList", "LoadingV2");

var showAddScreen = Recoil$OrcaPaymentPage.atom("showAddScreen", false);

var managePaymentMethod = Recoil$OrcaPaymentPage.atom("managePaymentMethod", "");

var savedMethodsV2 = Recoil$OrcaPaymentPage.atom("savedMethodsV2", [UnifiedHelpersV2$OrcaPaymentPage.defaultCustomerMethods]);

export {
  paymentManagementList ,
  showAddScreen ,
  managePaymentMethod ,
  savedMethodsV2 ,
}
/* paymentManagementList Not a pure module */
